import React from "react";
import FormGroup from "./FormGroup";
import Checkbox from "./Checkbox";
import NumberSwitch from "./NumberSwitch";

export default function NumberLimitFormGroup({
  error,
  valid = !error,
  additionalInfo,
  help,
  required,
  disabled,
  readOnly,
  wrapperClassName,
  label,
  value,
  onFocus,
  onBlur,
  onChange,
  min,
  max,
}) {
  return (
    <FormGroup error={error} valid={valid} required={required} className={wrapperClassName}>
      <Checkbox
        checked={value !== null}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(checked) => onChange(checked ? min || 0 : null)}
        label={label}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        toggle
      />
      <span style={{ visibility: value === null ? "hidden" : "visible" }} className="u-marginLeft">
        <NumberSwitch
          value={value}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          min={min}
          max={max}
          disabled={disabled}
          readOnly={readOnly}
        />
      </span>
      {!!additionalInfo && <span className="u-marginLeft">{additionalInfo}</span>}
      {!!help && <div className="ui help">{help}</div>}
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/NumberLimitFormGroup.jsx